import { useEffect, useState } from 'react';

const KEY = 'dealCode';
const TTL = 7 * 24 * 3600 * 1000;
const clean = (v) => (v || '').toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 30);

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const trackDeal = (code, event) => {
  if (!code) return;
  fetch(`${API_URL}/api/public/deal-event`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code, event, path: window.location.pathname.slice(0, 200) }) }).catch(() => {});
};

export const readDealCode = () => {
  try {
    const d = JSON.parse(localStorage.getItem(KEY) || 'null');
    return d && Date.now() - d.ts < TTL ? d.code : '';
  } catch { return ''; }
};

// `?deal=CODE` on any public page (newsletter / WhatsApp links) → remembered for a week and pre-applied everywhere.
export const useDealCode = () => {
  const [code, setCode] = useState(() => {
    const fromUrl = clean(new URLSearchParams(window.location.search).get('deal'));
    if (fromUrl) { localStorage.setItem(KEY, JSON.stringify({ code: fromUrl, ts: Date.now() })); trackDeal(fromUrl, 'open'); }
    return fromUrl || readDealCode();
  });
  useEffect(() => {
    const onStorage = () => setCode(readDealCode());
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
  const save = (c) => { const v = clean(c); if (v) localStorage.setItem(KEY, JSON.stringify({ code: v, ts: Date.now() })); else localStorage.removeItem(KEY); setCode(v); };
  return [code, save];
};

export const PROMO_LABEL = { basic: 'Deal', early_booker: 'Early booker deal', last_minute: 'Last-minute deal', secret: 'Secret deal' };

// Deals that apply to one room (promo.rooms are Beds24 room ids; empty = all rooms).
export const dealsForRoom = (promos, beds24Id) => (promos || []).filter((p) => !p.rooms?.length || p.rooms.map(String).includes(String(beds24Id)));
